const theme = {
    primary: "#000080",
    secondary:"#ff4500",
    white:"#ffffff",
    black:"#000000"
}

export default theme